// extracted by mini-css-extract-plugin
export default {"section":"inicio-section_section__reZ+i","title":"inicio-section_title__9D5M1"};